export type TeamMember = {
  name: string
  role: string
  bio: string
  image: string | null
  links: { label: string; url: string }[]
}

/**
 * Leadership.
 *
 * NOTE: the role here was 'Founder, CTO & CEO' — one person holding both the
 * technical and commercial side — and the About page still carries a paragraph
 * that leans on exactly that ("the person setting technical direction is also
 * the person running the business"). The role is now 'Founder & CEO', so that
 * claim is only true if the CTO seat is unfilled. If someone else holds it,
 * either add them here or cut that paragraph — do not leave an unsupported
 * claim on the page.
 *
 * The bio below is deliberately short. Every clause in it is sourced — either
 * supplied directly (name, role) or already published elsewhere on this site
 * (the "you deal with the decision-maker from the first conversation" promise
 * on the home and contact pages). Nothing about her background, years in the
 * industry, previous companies or specialisms is stated, because none of that
 * has been supplied, and inventing it would put an unverifiable claim about a
 * named person on her own company's site.
 *
 * To lengthen it, add real detail — do not pad it with plausible phrasing.
 *
 * TODO: social profiles are still missing; add them to `links` and they feed
 * `sameAs` in the Organization schema (SPEC.md §20).
 */
export const team: TeamMember[] = [
  {
    name: 'Rafia Sultana Smrity',
    role: 'Founder & CEO',
    bio: 'Rafia Sultana Smrity founded Softife and leads it as CEO. She is involved in engagements from the first conversation onward, so the person you scope a project with is the person accountable for delivering it.',
    /** 256x256 WebP, cropped from the supplied portrait. Rendered at 80px. */
    image: '/team/founder.webp',
    links: [
      // { label: 'LinkedIn', url: 'https://www.linkedin.com/in/...' },
      // { label: 'GitHub', url: 'https://github.com/...' },
    ],
  },
]

/**
 * Credibility numbers. Every one of these is either measured or absent —
 * never estimated. An unverifiable statistic is the first thing a serious
 * buyer checks.
 */
export const companyStats: { label: string; value: string }[] = [
  // { label: 'Years operating', value: 'TODO' },
  // { label: 'Projects delivered', value: 'TODO' },
]

export const hasCompanyStats = companyStats.length > 0
